import { t, Trans } from '@lingui/macro';
import { Button, ButtonProps, Dialog, DialogProps, Group, Icon, Spinner } from '@economic/taco';

import { ProgressDots } from '~/app/shared/components/ui/progressDots/ProgressDots';
import myntLogo from '../asset/MyntLogoSmall.svg';
import { usePaymentCardsOnboardingDialog } from './useOnboardingDialog';
import type { StepConfigStepAction } from './types';

interface ActionButtonProps {
    stepState: StepConfigStepAction;
    appearance: ButtonProps['appearance'];
    onClick: () => void;
}
const ActionButton = ({ appearance, stepState, onClick }: ActionButtonProps) => {
    const { state } = usePaymentCardsOnboardingDialog();

    return (
        <Button disabled={stepState.isDisabled?.(state)} onClick={onClick} appearance={appearance}>
            {stepState.text}
            {stepState.icon && <Icon name={stepState.icon} />}
        </Button>
    );
};

const myntIcon = () => <img src={myntLogo} alt="Mynt" />;

const PaymentCardsOnboardingDialogComponent = (dialogProps: Partial<DialogProps>) => {
    const { state, currentConfig, onContinue, onBack, onCloseDialog } = usePaymentCardsOnboardingDialog();
    const { index, next, prev, Component } = currentConfig;

    return (
        <Dialog size="xs" {...dialogProps} onClose={onCloseDialog}>
            <Dialog.Content aria-label={t`Company Card onboarding flow`} className="!p-0 relative">
                <Dialog.Title className="px-6 pt-6">
                    <ProgressDots stepsCount={4} currentStep={index} withCompleteTicks={false} customFinalIcon={myntIcon} />
                </Dialog.Title>
                <main className="px-6 pt-4">
                    <Component />
                    <Group className="flex justify-end">
                        {prev && <ActionButton appearance="default" stepState={prev} onClick={onBack} />}
                        {next && <ActionButton appearance="primary" stepState={next} onClick={onContinue} />}
                    </Group>
                </main>
                <Dialog.Footer className="bg-grey-100 flex items-center p-4 h-14 gap-2 !justify-start">
                    <Trans>We collaborate with</Trans>
                    <img src={myntLogo} alt="Mynt" width={24} height={24} />
                    <span className="text-2xl">Mynt</span>
                </Dialog.Footer>
                {state.isLoading && (
                    <div className="absolute inset-0 bg-white flex justify-center items-center bg-opacity-50">
                        <Spinner />
                    </div>
                )}
            </Dialog.Content>
        </Dialog>
    );
};

export default PaymentCardsOnboardingDialogComponent;
